import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { GitlabRepoLocationPicker } from './GitlabRepoLocationPicker';
import { gitlabRepoLocationValidation } from './validation';
import { scaffolderPlugin } from '@backstage/plugin-scaffolder';

export const GitlabRepoLocationPickerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'GitlabRepoLocationPicker',
    component: GitlabRepoLocationPicker,
    validation: gitlabRepoLocationValidation,
  }),
);
